import { PushMessage } from '../services/signalr-service';

export class BroadcastMessage {

    messageType: PushMessage;
    data: any;
    userName: string;
    isThisUser: boolean;

}